/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const List = (props) => {
  const classes = classnames('cmp-list', {
    'has-border': props.hasBorder,
    'large-padding': props.paddingSize === 'large',
    'default-padding': props.paddingSize === 'default',
    'last-child-no-border': !props.lastChildHasBorder,
    'first-child-no-top-padding': props.firstChildHasOnlyBottomPadding,
    'has-rounded-wrapper': props.hasRoundedWrapper,
  });

  return (
    <ul className={classes}>
      {props.children}
    </ul>
  );
};
List.propTypes = {
  children: PropTypes.any.isRequired,
  hasBorder: PropTypes.bool,
  paddingSize: PropTypes.oneOf(['large', 'default']),
  lastChildHasBorder: PropTypes.bool,
  firstChildHasOnlyBottomPadding: PropTypes.bool,
  hasRoundedWrapper: PropTypes.bool,
};

export const ListItem = (props) => {
  const classStyles = classnames(props.className, 'util-application-frame-forcards-padding ', {
    'util-list-bottom-border-dark': props.hasBottomBorder,
    'is-clickable': !props.disabled && !!props.onClick,
    'large-padding': props.paddingSize === 'large',
    'default-padding': props.paddingSize === 'default',
    'util-disabled': !!props.disabled,
  });

  return (
    <li className={classStyles} onClick={props.onClick} style={props.style}>
      {props.children}
    </li>
  );
};
ListItem.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  hasBottomBorder: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  paddingSize: PropTypes.oneOf(['large', 'default']),
  disabled: PropTypes.bool,
};


export const BasicListItem = (props) => {
  const classStyles = classnames(props.className, {
    'util-list-bottom-border-dark': props.hasBottomBorder,
    'is-clickable': !props.disabled && !!props.onClick,
    'large-padding': props.paddingSize === 'large',
    'default-padding': props.paddingSize === 'default',
    'util-disabled': !!props.disabled,
  });

  return (
    <li className={classStyles} onClick={props.onClick} style={props.style}>
      {props.children}
    </li>
  );
};
BasicListItem.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  hasBottomBorder: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  paddingSize: PropTypes.oneOf(['large', 'default']),
  disabled: PropTypes.bool,
};

export const ListItemExternalLink = (props) => {
  const classStyles = classnames(props.className, 'cmp-listitem-link', {
    'util-list-bottom-border-dark': props.hasBottomBorder,
    'large-padding': props.paddingSize === 'large',
    'default-padding': props.paddingSize === 'default',
  });

  return (
    <li className={classStyles} style={props.style}>
      <a className="util-application-frame-forcards-padding is-clickable" target="_blank" href={props.href} rel="noopener noreferrer" onClick={props.onClick}>
        {props.children}
      </a>
    </li>
  );
};
ListItemExternalLink.propTypes = {
  children: PropTypes.any.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  hasBottomBorder: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  paddingSize: PropTypes.oneOf(['large', 'default']),
};

export const NestedListGroup = (props) => (
  <div className="cmp-list--nested">
    {props.children}
  </div>
);
NestedListGroup.propTypes = {
  children: PropTypes.any.isRequired,
};

export const ListDivider = (props) => {
  const classStyles = classnames('cmp-list-divider', {
    'util-application-frame-forcards-padding': !props.noPadding,
  });
  return (
    <div className={classStyles}>
      <hr />
    </div>
  );
};
ListDivider.propTypes = {
  noPadding: PropTypes.any.isRequired,
};

export const CardListItem = (props) => (
  <BasicListItem {...props} className={classnames(props.className, 'cmp-cardlistitem util-application-card-padding')} />
);
CardListItem.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any,
  hasBottomBorder: PropTypes.bool,
  style: PropTypes.any,
};

export const TextList = (props) => (
  <ul className="cmp-textlist" style={props.style}>{props.children}</ul>
);
TextList.propTypes = {
  style: PropTypes.object,
  children: PropTypes.any,
};

export const FootnoteTextList = (props) => (
  <ul className="cmp-footnotetextlist font-footnote" style={props.style}>{props.children}</ul>
);
FootnoteTextList.propTypes = {
  style: PropTypes.object,
  children: PropTypes.any,
};

export default List;
